export const focusAreas = [
  {
    slug: "agro-food-products",
    title: "Agro & Food Products",
    image: "/assets/approved-agro-food.jpg",
    alt: "Indian rice, grains, pulses, nuts, spices and fresh ingredients arranged for trade",
    summary: "A lead focus area for buyer-led sourcing conversations across agricultural and food products.",
    items: "Rice, wheat, pulses, nuts, dry fruits, ginger, garlic, onion, spices and more.",
    brief: ["Product specification", "Destination market", "Quantity expectations", "Packaging preferences"],
  },
  {
    slug: "plastics",
    title: "Plastics",
    image: "/assets/approved-plastics.jpg",
    alt: "Plastic films, pellets, bottles, pipes and containers in a manufacturing setting",
    summary: "A current focus area for plastic product and material sourcing enquiries.",
    items: "Buyer-defined plastic products, materials and related requirements.",
    brief: ["Material or product details", "Intended application", "Destination market", "Packaging requirements"],
  },
  {
    slug: "leather-leather-goods",
    title: "Leather & Leather Goods",
    image: "/assets/approved-leather-goods.jpg",
    alt: "Leather materials, bags, footwear and accessories presented for trade",
    summary: "A current focus area for leather material and finished-goods sourcing enquiries.",
    items: "Leather materials, accessories, bags, footwear and other buyer-specified goods.",
    brief: ["Material preference", "Product reference", "Finish and colour direction", "Destination market"],
  },
  {
    slug: "garments",
    title: "Garments",
    image: "/assets/approved-garments.jpg",
    alt: "Finished garments, fabrics and garment production materials",
    summary: "A current focus area for garment and apparel sourcing enquiries.",
    items: "Buyer-specified apparel, fabrics and garment requirements.",
    brief: ["Garment type", "Fabric preference", "Size and colour requirements", "Target market"],
  },
  {
    slug: "handicrafts",
    title: "Handicrafts",
    image: "/assets/approved-handicrafts.jpg",
    alt: "Indian handcrafted decor, textiles, ceramics and artisanal goods",
    summary: "A current focus area for Indian handcrafted and artisanal product enquiries.",
    items: "Decor, textiles, ceramics and other buyer-specified handcrafted goods.",
    brief: ["Product style", "Material direction", "Reference images", "Destination market"],
  },
  {
    slug: "chemicals",
    title: "Chemicals",
    image: "/assets/approved-chemicals.jpg",
    alt: "Chemical materials and laboratory vessels within an industrial setting",
    summary: "A current focus area for buyer-led chemical sourcing enquiries.",
    items: "Buyer-specified chemical products and related requirements.",
    brief: ["Product specification", "Grade or application", "Packaging requirements", "Destination market"],
  },
  {
    slug: "electronics-electricals",
    title: "Electronics & Electricals",
    image: "/assets/approved-electronics-electricals.jpg",
    alt: "Electrical components, circuit boards, cables and industrial electronics",
    summary: "A current focus area for electronics and electrical sourcing enquiries.",
    items: "Buyer-specified electronic and electrical products or components.",
    brief: ["Technical specification", "Product application", "Quantity expectations", "Destination market"],
  },
];

export function findFocusArea(slug) {
  return focusAreas.find((area) => area.slug === slug);
}
